import React, { useState } from "react";

const SocialData = () => {
  const [disabledInputs, setDisabledInputs] = useState();

  const data = [
    {
        metric: "Staff turnover",
        question: "What is the percentage of employees leaving p.a./total employees?",
        unit: "Percentage",
        sector: "General",
        example: "2%"
    
    },
    {
        metric: "Training & qualification",
        question: "What is the percentage of trained employees p.a./total employees ?",
        unit: "Number",
        sector: "General",
        example: "68%"
    },
    {
        metric: "Training & qualification",
        question: "What is the annual training hours per employee ?",
        unit: "Hours / Employee",
        sector: "General",
        example: "740"
    },
    {
        metric: "Number of employees",
        question: " What is the number of employees by employment type(full time and part time)(by gender) ?",
        unit: "Number",
        sector: "General",
        example: "1080"
    },
    {
        metric: "Health & safety aspects of products",
        question: "What is the  total spendings on product safety / revenue ?",
        unit: "Percentage",
        sector: "General",
        example: "40%"
    },
    {
        metric: "Diversity",
        question: "What is the percentage of female employees as of total ?",
        unit: "Percentage",
        sector: "General",
        example: "48%"
    }

]

  const toggleInput = (index) => {
  
    setDisabledInputs(index)
    if(index==disabledInputs){
        setDisabledInputs(null)
    }
  };

  return (
    <>
      <div className="socialtab">
        <table className="table">
          <thead>
            <tr>
            <th scope="col">Metric</th>
              <th scope="col">Question</th>
              <th scope="col">Inputs</th>
             
              <th scope="col">Unit</th>
              
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((curData, index) => {
                const { question, metric, unit } = curData;

                return (
                  <tr key={index}>
                    <td>{metric}</td>
                    <td>{question}</td>
                    <td>
                      <input
                        type="number"
                        className="removearrow"
                        disabled={disabledInputs==index ? false:true}
                      />
                      <i
                        className="fa-regular fa-pen-to-square editable-inputbox"
                        onClick={() => toggleInput(index)}
                      ></i>
                    </td>
                    
                    <td>{unit}</td>
                 
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6">No Social reports data available.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default SocialData;
